import axiosInstance from "../axiosInstance";

const BASE = "/server/buccl_lessons/api/v1/lesson-products/";

export const lessonOptionsService = {
  // 옵션 그룹
  listGroups: (lessonProductId: number) => axiosInstance.get(`${BASE}${lessonProductId}/options/`),
  createGroup: (lessonProductId: number, payload: Record<string, unknown>) => axiosInstance.post(`${BASE}${lessonProductId}/options/`, payload),
  updateGroup: (lessonProductId: number, groupId: number, payload: Record<string, unknown>) => axiosInstance.patch(`${BASE}${lessonProductId}/options/${groupId}/`, payload),
  deleteGroup: (lessonProductId: number, groupId: number) => axiosInstance.delete(`${BASE}${lessonProductId}/options/${groupId}/`),

  // 옵션 값
  createValue: (lessonProductId: number, groupId: number, payload: Record<string, unknown>) => axiosInstance.post(`${BASE}${lessonProductId}/options/${groupId}/values/`, payload),
  updateValue: (lessonProductId: number, groupId: number, valueId: number, payload: Record<string, unknown>) => axiosInstance.patch(`${BASE}${lessonProductId}/options/${groupId}/values/${valueId}/`, payload),
  deleteValue: (lessonProductId: number, groupId: number, valueId: number) => axiosInstance.delete(`${BASE}${lessonProductId}/options/${groupId}/values/${valueId}/`),
};
